// extracted by mini-css-extract-plugin
export var dowloadpdf = "alternateContainer-module--dowloadpdf--7e479";
export var sectionContainer = "alternateContainer-module--section-container--fa51c";